// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--1wP_J","highElevation":"card-module--highElevation--1_S7l","hoverable":"card-module--hoverable--3O2w1"};